import axios from "axios";

//---------------GET CATEGORIES---------------------

export const getAllCategories = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/category/get-all-categories`,
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
